import videojs from 'video.js'
import register_vtt_thumbnails from 'videojs-vtt-thumbnails'
import register_mobile_improvements from './mobile-improvements'
import register_download_button from './download-mux-mp4'
import 'videojs-contrib-quality-levels'
import 'videojs-hls-quality-selector'
import 'videojs-mux'
import 'videojs-hotkeys'

import 'video.js/dist/video-js.css'
import 'videojs-vtt-thumbnails/index.css'
import './index.css'

register_vtt_thumbnails(videojs)
register_mobile_improvements(videojs)
register_download_button(videojs)

export default function({ mux_playback_id, target, mux_data, options = {}, thumbnail_timecode_seconds, duration_seconds, title }) {
	const player = videojs(target, {
		controls: true,
		plugins: {
			mux: {
				debug: false,
				data: {
					...mux_data,
					player_init_time: Date.now(),
				},
			},
		},
		playbackRates: [ 0.5, 1, 1.25, 1.5, 1.75, 2 ],
		...options,
	})

	player.duration = () => duration_seconds

	player.src({
		src: `https://stream.mux.com/${ mux_playback_id }.m3u8`,
		type: `application/x-mpegURL`,
	})

	player.vttThumbnails({
		src: `https://image.mux.com/${ mux_playback_id }/storyboard.vtt`,
	})

	player.poster(`https://image.mux.com/${ mux_playback_id }/thumbnail.jpg?time=${ thumbnail_timecode_seconds || 5 }`)

	player.qualityLevels()

	player.hlsQualitySelector()

	player.downloadButton({ mux_playback_id, title })

	player.hotkeys({
		alwaysCaptureHotkeys: true,
	})

	player.on(`mouseleave`, () => {
		setTimeout(() => player.userActive(false))
	})

	const title_element = document.createElement(`div`)
	title_element.classList.add(`video_title`)
	title_element.innerText = title
	player.el_.appendChild(title_element)

	// don't control volume with wheel.  or anything, for that matter
	player.el_.addEventListener(`wheel`, e => e.stopPropagation())

	return player
}
